import { Icon, IconProps } from "../";

export const PillLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.22164 11.2929C1.8785 13.636 1.8785 17.435 4.22164 19.7782C6.56479 22.1213 10.3638 22.1213 12.7069 19.7782L15.7121 16.773L19.778 12.7071C22.1211 10.3639 22.1211 6.56496 19.778 4.22181C17.4348 1.87867 13.6359 1.87867 11.2927 4.22181L9.34817 6.16636C9.05528 6.45925 9.05528 6.93412 9.34817 7.22702C9.64106 7.51991 10.1159 7.51991 10.4088 7.22702L12.3534 5.28247C14.1107 3.52512 16.96 3.52512 18.7173 5.28247C20.4747 7.03983 20.4747 9.88908 18.7173 11.6464L15.1818 15.182L8.28751 8.28768C7.99462 7.99478 7.51974 7.99479 7.22685 8.28768L4.22164 11.2929ZM7.75718 9.87867L5.2823 12.3535C3.52495 14.1109 3.52495 16.9601 5.2823 18.7175C7.03966 20.4749 9.88891 20.4749 11.6463 18.7175L14.1211 16.2426L7.75718 9.87867Z"
      />
    </Icon>
  );
};
